import useIsInappWebview from "./useIsInappWebview";
import useGetDeviceInfo from "./useGetDeviceInfo";
import { compareVersions } from "../logic/logics_common";
import { isDev } from "config";

export default function useIsSecuritySettingsAvailable() {
  const isInappWebview = useIsInappWebview();
  const { appVersion } = useGetDeviceInfo();

  return (
    isDev || (isInappWebview && compareVersions(appVersion, "1.1.31") >= 0)
  );
}
